import { useEffect } from "react"
import { useFormContext } from "react-hook-form"
import { UserShape } from "~shapes/user"
import { WizardColumn, WizardRow } from "~styled/wizard"
import Input from "~app/Input"
import { ERROR_MESSAGES } from "~constants/errorMessages"
import { Form } from "~styled/form"
import { userInitialState } from "../../../initialStates"

interface Props {
  user: UserShape
}

const UserShippingAddress = ({ user }: Props) => {
  const { formState: { errors }, register, reset } = useFormContext()
  const shippingAddress =
    user?.shippingAddress || userInitialState.shippingAddress

  useEffect(() => {
    reset({
      addressLine1: shippingAddress?.addressLine1 || "",
      addressLine2: shippingAddress?.addressLine2 || "",
      city: shippingAddress?.city,
      postal: shippingAddress?.postal,
      state: shippingAddress?.state,
      phoneNumber: shippingAddress?.phoneNumber,
    })
  }, [])

  return (
    <Form>
      <WizardRow>
        <WizardColumn>
          <Input
            name="addressLine1"
            label="Address line 1"
            register={register("addressLine1", {
              required: true,
              minLength: {
                value: 6,
                message: "Should be at least 6 characters.",
              },
            })}
            errorMessage={
              errors.addressLine1 &&
              (errors.addressLine1.message || ERROR_MESSAGES.FIELD_REQUIRED)
            }
          />
        </WizardColumn>

        <WizardColumn>
          <Input
            name="addressLine2"
            label="Address line 2"
            register={register("addressLine2", {
              minLength: {
                value: 6,
                message: "Should be at least 6 characters.",
              },
            })}
            errorMessage={
              errors.addressLine2 &&
              (errors.addressLine2.message || ERROR_MESSAGES.FIELD_REQUIRED)
            }
          />
        </WizardColumn>
      </WizardRow>

      <WizardRow>
        <WizardColumn>
          <Input
            name="city"
            label="City"
            register={register("city", {
              required: true,
            })}
            errorMessage={errors.city && ERROR_MESSAGES.FIELD_REQUIRED}
          />
        </WizardColumn>

        <WizardColumn>
          <Input
            name="postal"
            label="Zip Code"
            register={register("postal", {
              required: true,
            })}
            errorMessage={errors.postal && ERROR_MESSAGES.FIELD_REQUIRED}
          />
        </WizardColumn>
      </WizardRow>

      <WizardRow>
        <WizardColumn>
          <Input
            name="state"
            label="State"
            register={register("state", {
              required: true,
              maxLength: {
                value: 3,
                message: " Maximum is 3 characters.",
              },
            })}
            errorMessage={
              errors.state &&
              (errors.state.message || ERROR_MESSAGES.FIELD_REQUIRED)
            }
          />
        </WizardColumn>

        <WizardColumn>
          <Input
            name="phoneNumber"
            label="Phone Number"
            register={register("phoneNumber", {
              required: true,
            })}
            errorMessage={errors.phoneNumber && ERROR_MESSAGES.FIELD_REQUIRED}
          />
        </WizardColumn>
      </WizardRow>
    </Form>
  )
}

export default UserShippingAddress
